import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import MessageEventPreview from "go-component/components/MessageEvent/MessageEventPreview";
import { MessageEventContext } from "go-component/components/MessageEvent/services/context";
import { MessageEventApi } from "go-component/components/MessageEvent/services/types";
import { parseApiData } from "go-core/api/parseApiData";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";

interface MatchParams {
	log_id: string;
}

const OrganizationLogsMessageEventsPreviewPage = () => {
	const { t } = useTranslation();
	const [messageEvent, setMessageEvent] = useState<MessageEventApi | undefined>();
	const messageEventService = useContext(MessageEventContext);
	const { addFlash } = useFlash();
	const { log_id } = useParams<MatchParams>();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	const fetch = async (logId: string) => {
		const params = { include: "logs,resources,resources.entity_id" };
		try {
			const res = await parseApiData(messageEventService.api().get(logId, params));
			setMessageEvent(res);
			handleChangeTabTitle(
				`${messageEventService.getMessageEventTypeTitle(res.type)} | ${t(
					"lib:go_component.message_events.header.title"
				)}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};
	useEffect(() => {
		fetch(log_id);
	}, []);

	if (!messageEvent) {
		return <LoadingContainer />;
	}

	return <MessageEventPreview messageEvent={messageEvent} />;
};

export default OrganizationLogsMessageEventsPreviewPage;
